import { SyntheticEvent, useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Text from '../../../../global/text/text';
import ChevronSVG from '../../../../../images/svg/icons8-expand-arrow';
import { Popover } from '../../../../global/popover/popover';

interface IProps {
    selectedAttendeeFilter: string;
    setAttendeeFilter: (state?) => void;
}

enum AttendeeFilterValues {
    Organization = 'Organization',
    Attendee = 'Attendee'
}

const AttendeeAndOrganizationDropdown = (props: IProps) => {
    const {selectedAttendeeFilter, setAttendeeFilter} = props;
    const buttonRef = useRef(null);
    const [isModalOpen, setModalOpen] = useState(false);

    const getStatusButtonText = () => {
        return `Sort by: ${selectedAttendeeFilter}`;
    };

    const statusOptions = [
        {label: AttendeeFilterValues.Organization, id: 'oe.common.organization', value: false},
        {label: AttendeeFilterValues.Attendee, id: 'oe.common.attendee', value: true}
    ];

    return (
        <div
            className={classnames('cell-header-button attendee-filter', {
                'cell-header-button--active': isModalOpen,
            })}
            ref={buttonRef}
            onClick={() => setModalOpen(prevState => !prevState)}
        >
            <div className='cell-header-button__wrapper'>
                <Text
                    className={classnames('cell-header-button__label')}
                    message={getStatusButtonText()}
                    withEllipsis
                />
                <ChevronSVG/>
            </div>
            <Popover
                padding={0}
                isOpen={isModalOpen}
                buttonRef={buttonRef}
                customWidth={buttonRef.current?.getBoundingClientRect().width}
                onClickOutside={() => setModalOpen(false)}
                align='start'
            >
                <div className='status-button__options'>
                    {statusOptions.map(el =>
                        <div
                            className={classnames('status-button__option', {
                                'status-button__option--selected': el.label === selectedAttendeeFilter
                            })}
                            key={el.label}
                            onClick={(e: SyntheticEvent) => {
                                e.stopPropagation();
                                setModalOpen(false);
                                if (el.label === AttendeeFilterValues.Organization) {
                                    setAttendeeFilter(AttendeeFilterValues.Organization);
                                } else {
                                    setAttendeeFilter(AttendeeFilterValues.Attendee);
                                }
                            }}
                        >
                            {
                                el.id ? <FormattedMessage
                                    id={el.id}
                                    defaultMessage={el.label}
                                    description='Attendee status button text'
                                /> : el.label
                            }
                        </div>
                    )}
                </div>
            </Popover>
        </div>
    );
};

export default AttendeeAndOrganizationDropdown;